import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel';
import SimpleSubClocksComponent from './TimelineSimpleSubClocksComponent.vue'
import { Timespending } from '@/app.context/workspace/Event';
import { Direction, SegmentEnd } from '@/logic/_infra/_tech';
import { TimeSegment } from '@/logic/_infra/time';
import EffortComponent from './EffortComponent_Timeline.vue'
import TimelineClocksComponent from './TimelineClocksComponent.vue'
import {emits, offset as offset_f} from '@/components/Workspaces/persons/_spec/timeline/clock_timeline'



export default /*#__PURE__*/_defineComponent({
  __name: 'TwitlightComponent_Timeline',
  props: {
    efforts: {},
    offset: {}
  },
  emits: emits,
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const offset = offset_f(props)

function click(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

    emit("click", d, e, effort, timeffort, timespending)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.efforts, (item, i) => {
      return (_openBlock(), _createElementBlock("li", { key: i }, [
        (item.timeffort != null)
          ? (_openBlock(), _createBlock(SimpleSubClocksComponent, {
              key: 0,
              item: item,
              onClick: click,
              timeffort: null,
              timepoint: item.segment_value.timepoint,
              edge: 'E',
              offset: _unref(offset)
            }, null, 8, ["item", "timepoint", "offset"]))
          : (_openBlock(), _createBlock(TimelineClocksComponent, {
              key: 1,
              item: item,
              onClick: click,
              offset: _unref(offset)
            }, null, 8, ["item", "offset"])),
        _createVNode(EffortComponent, {
          item: item,
          onClick: click,
          offset: _unref(offset)
        }, null, 8, ["item", "offset"])
      ]))
    }), 128))
  ]))
}
}

})